module.exports = __webpack_public_path__ + "images/ReferFriendImage_5339df0.png";